<template>
  <el-form-item v-bind="itemBinds" class="master-table" label-width="0">
    <!-- header -->
    <div class="master-table-header">
      <FormHeader>{{ $t('performanceAppraisal.performanceAppraisal.formTitle.processDetail') }}</FormHeader>
    </div>
    <template v-if="tableData.length > 0">
      <div class="main-content">
        <div class="right-content">
          <!-- <el-scrollbar ref="scrollbar" style="height: 100%; width: 100%;"> -->
          <el-table
            :data="tableData"
            :style="tableWidth"
            max-height="325px"
            :header-row-style="styleFunc"
            :cell-style="columnStyle"
          >
            <template v-for="item in originColumn">
              <el-table-column :key="item.origin" fixed="left" :label="item.tabName" :width="item.width">
                <template v-for="itemNew in item.columns">
                  <el-table-column :key="itemNew.prop" :prop="itemNew.prop" :label="itemNew.quotaName" :width="itemNew.width">
                    <template v-slot="{ row, column }">
                      <span style="font-weight: 600;">{{ row[column.property] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table-column>
            </template>
            <template v-for="(item, index) in columns">
              <el-table-column :key="index" :label="item.tabName">
                <el-table-column v-for="(itemNew, number) in item.columns" :key="number" width="200" :prop="itemNew.quotaName" :label="itemNew.quotaName">
                  <template v-slot="{ row, column }">
                    <span>{{ row[column.property] }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>
          </el-table>
          <!-- </el-scrollbar> -->
        </div>
      </div>
    </template>
    <template v-else>
      <Empty />
    </template>
  </el-form-item>
</template>

<script>
import FormHeader from '@/components/form/form-header/form-header.vue'
import Empty from './small/empty.vue'

export default {
  name: 'NoEvaluationSysTable',
  components: {
    FormHeader,
    Empty
  },
  props: {
    itemBinds: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      originColumn: [{
        tabName: this.$t('performanceAppraisal.performanceAppraisal.rateInfo'), origin: 'origin', width: '600', columns: [
          { quotaName: '#', data: '', prop: 'index', width: '50' },
          { quotaName: this.value.judgeTypeName, width: '200', data: '', prop: 'groupName' },
          { quotaName: this.$t('performanceAppraisal.performanceAppraisal.score'), width: '100', data: '', prop: 'sumMark' },
          { quotaName: this.$t('performanceAppraisal.performanceAppraisal.level'), width: '100', data: '', prop: 'supplierLevel' },
          { quotaName: this.$t('performanceAppraisal.performanceAppraisal.supBatLevel'), width: '150', data: '', prop: 'supBatLevel' }
        ] }
      ],
      tableData: [],
      columns: [],
      indexArr: [],
      allData: [],
      tableWidth: {}
    }
  },
  computed: {
    total() {
      return this.examListCopy?.length || 0
    }
  },
  created() {
    this.init(this.value)
  },
  methods: {
    init(data) {
      this.allData = data
      if (this.columns.length === 0) {
        this.columns.push(...data['tabHeadInfo'] || [])
      }
      this.tableData = data.tabData || []
      // 按照number字段排序
      this.columns = this.columns.sort(this.sortsFun('number'))
      this.columns.map((item) => {
        item.columns = item.columns.sort(this.sortsFun('number'))
      })
      console.log(this.columns)
      // 计算分开
      let number = 0
      const column = this.originColumn.concat(this.columns)
      this.indexArr = []
      column.map((item) => {
        this.indexArr.push(item.columns.length + number - 1)
        number += item.columns.length
      })
      this.tableWidth = { width: ((number * 231) + 250) + 'px' }
    },
    styleFunc(row) {
      if (row.rowIndex === 0) {
        return 'color: #333; fontSize: 14px; font-weight: 500;margin: 0 2px;'
      }
      if (row.rowIndex === 1) {
        return 'color: #333; fontSize: 13px; font-weight: 400;'
      }
    },
    columnStyle({ columnIndex }) {
      if (this.indexArr.includes(columnIndex)) {
        return 'border-right: 2px solid #EBEEF5'
      }
    },
    sortsFun(arr) {
      return function(a, b) {
        const v1 = a[arr]
        const v2 = b[arr]
        return v1 - v2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.master-table-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.main-content {
  max-height: 380px;
  width: 100%;
  display: flex;
  .right-content {
    width: 100%;
    height: 100%;
    overflow: hidden;
    &:hover {
      overflow-x: auto;
    }
  }
}

.input-header {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  .search-icon {
    cursor: pointer;
  }
}
.examine-table-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 15px;
}
/deep/ .el-table .cell > span {
  font-weight: 500 !important;
  font-family: "Microsoft YaHei", serif !important;
}

</style>
